<template>
  <div :class="viewer ? '' : 'page'">
    <div v-if="!viewer">
      <div class="feature-intro">
        <h1>Nuevo {{ localConfig.pageName }}</h1>
        <p>Ingrese los datos del formulario</p>
      </div>
    </div>

    <div v-if="!showTForm || loading" class="spinner-wrapper">
      <ProgressSpinner
        style="width: 50px; height: 50px"
        strokeWidth="5"
        fill="#EEEEEE"
        animationDuration="1.5s"
      />
      <p v-if="loading" class="loading-text">GUARDANDO...</p>
    </div>

    <TForm
      v-if="showTForm"
      v-show="localConfig && !loading"
      :config="config"
      :data="localConfig.data"
      :designNew="localConfig.design"
      :dropdown="localConfig.dropdown || {}"
      :errors="localConfig.errors"
      :labels="config.data.labels || {}"
      :mensajes="localConfig.mensajes"
      mode="new"
      :nombres="localConfig.names"
      :placeholder="localConfig.placeholder || {}"
      :url="localConfig.url"
      :viewer="viewer"
      :viewerID="viewerID"
      @errorDuplicatedEntry="handleDuplicatedEntryError"
      @saveAttempt="onTrying"
      @finishPetition="onfinishPetition"
    />

    <CustomModal
      title="Error de Duplicación"
      modalType="error"
      :message="errorMessage"
      :showIcon="true"
      :showSecondaryButton="false"
      @confirm="$refs.ModalRefDuplicated.close()"
      :buttonLabels="['Aceptar']"
      ref="ModalRefDuplicated"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import CustomModal from "@/components/CustomModal.vue";

export default {
  props: {
    viewer: { type: Boolean, default: false },
    viewerID: { type: String, default: "" },
    config: { type: Object, default: () => ({}) },
  },
  components: {
    CustomModal,
  },
  data() {
    return {
      showTForm: false,
      loading: false,
      errorMessage: "",
    };
  },
  async created() {
    this.showTForm = false;
    await Promise.all([
      this.$store.dispatch("siis/setMarca"),
      this.$store.dispatch("siis/setSubCategoriasDeposito"),
      this.$store.dispatch("siis/setCategoriasDeposito"),
      this.$store.dispatch("siis/setTipoDeposito"),
      this.$store.dispatch("siis/setDepartamentales"),
    ]);
    this.showTForm = true;
  },
  async mounted() {
    if (this.localConfig.dropdown) {
      if (this.localConfig.dropdown.id_categoria) {
        this.localConfig.dropdown.id_categoria.changeDropdown = this.handleCategoriaChange;
      }
      if (this.localConfig.dropdown.id_subcategoria) {
        this.localConfig.dropdown.id_subcategoria.changeDropdown = this.handleSubcategoriaChange;
      }
      if (this.localConfig.dropdown.id_marca) {
        this.localConfig.dropdown.id_marca.refreshDropdown = this.refreshMarcaDropdown;
      }
      if (this.localConfig.dropdown.DepartamentalID) {
        this.localConfig.dropdown.DepartamentalID.refreshDropdown = await this.$store.dispatch(
          "siis/setDepartamentales",
          true
        );
        this.localConfig.dropdown.DepartamentalID.options = this.$store.state.siis.departamentales;
      }
    }
    // this.showTForm = true;
  },
  computed: {
    ...mapState({
      marca: (state) => state.siis.marca,
      subcategorias: (state) => state.siis.subcategoriasDeposito,
      categorias: (state) => state.siis.categoriasDeposito,
      tipo: (state) => state.siis.tipoDeposito,
      departamentales: (state) => state.siis.departamentales,
    }),
    localConfig() {
      if (this.config) {
        return this.config.data;
      } else {
        return {
          data: {},
          names: {},
          labels: {},
          placeholder: {},
          errors: {},
          mensajes: {},
          design: [],
          url: "",
          dropdown: {},
        };
      }
    },
  },

  watch: {
    subcategorias(updatedValue) {
      if (updatedValue && this.localConfig.dropdown && this.localConfig.dropdown.id_subcategoria) {
        this.localConfig.dropdown.id_subcategoria.options = updatedValue;
      }
    },
    categorias(updatedValue) {
      if (updatedValue && this.localConfig.dropdown && this.localConfig.dropdown.id_categoria) {
        this.localConfig.dropdown.id_categoria.options = updatedValue;
      }
    },
    marca(newValue) {
      if (
        newValue &&
        this.localConfig &&
        this.localConfig.dropdown &&
        this.localConfig.dropdown.id_marca
      ) {
        this.localConfig.dropdown.id_marca.options = newValue;
      }
    },
  },
  methods: {
    onTrying() {
      this.loading = true;
      // this.showTForm = false;
    },
    onfinishPetition() {
      this.showTForm = true;
      this.loading = false;
    },
    handleDuplicatedEntryError(message) {
      // this.showTForm = true;
      console.log(message);
      this.loading = false;
      this.errorMessage = message;
      this.$refs.ModalRefDuplicated.open();
    },
    handleCategoriaChange(value) {
      this.localConfig.dropdown.id_subcategoria.options = this.subcategorias.filter(
        (item) => item.id_categoria === value
      );
    },
    handleSubcategoriaChange(value) {
      this.localConfig.dropdown.id_tipo.options = this.tipo.filter(
        (item) => item.id_subcategoria === value
      );
    },
    refreshMarcaDropdown() {
      this.$store.dispatch("siis/setMarca", true);
    },
  },
};
</script>

<style scoped>
.spinner-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.loading-text {
  margin-top: 10px;
}
</style>
